import { render, staticRenderFns } from "./PageCreateStack.vue?vue&type=template&id=2b4e9d3d&"
import script from "./PageCreateStack.vue?vue&type=script&lang=js&"
export * from "./PageCreateStack.vue?vue&type=script&lang=js&"
import style0 from "./PageCreateStack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports